import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	dataForServer: [
		{}
	], // variable to update or create new
	canSaveLocation: false,
	location0: {},
	location1: {},
	location2: {},
	locationExist0: false,
	locationExist1: false,
	locationExist2: false,
	updatedLocationForServer: {} // process location name and set it here.

}

const getters = {
	// use this to display service location error.
	getLocationExist(state){
		var arr = [state.locationExist0, state.locationExist1, state.locationExist2];

		return arr;
	}
}


// mutations
const mutations = {
	CLEAR(state){
		state.canSaveLocation = false
		state.location0 = {}
		state.location1 = {}
		state.location2 = {}
	},

	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	UPDATE_SELECTED_DATA(state, {dataIndex, key, value}){
		var dataIndex = Number(dataIndex)
		switch(dataIndex){
			case 0:
				state.location0[key] = value;
				break;
			case 1:
				state.location1[key] = value;
				break;
			case 2:
				state.location2[key] = value;
				break;
		}
	},

	ADD_LOCATION(state, {dataIndex, clientId}){
		var dataIndex = Number(dataIndex)

		//console.log("line 49: "+dataIndex+' '+clientId);

		var key = 'client_id';
		var value = clientId;

		var data = {
			client_id: clientId
		}

		switch(dataIndex){
			case 0: 
				//Vue.set(state.location1, key, value);
				state.location0 = data;
				break;
			case 1: 
				//Vue.set(state.location2, key, value);
				state.location1 = data;
				break;
			case 2: 
				//Vue.set(state.location3, key, value);
				state.location2 = data;
				break;
		}
	},

	REMOVE_LOCATION(state, arrayIndex){
		state.dataForServer.splice(arrayIndex,1);
	},

	SET_UPDATED_LOCATION_FOR_SERVER(state, newLocationData){
		state.updatedLocationForServer = newLocationData;
	},
}

// actions
const actions = {
	setBoolean({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	updateSelectedData ({commit}, {dataIndex, key, value}){
		commit('UPDATE_SELECTED_DATA', {dataIndex: dataIndex, key: key, value: value})
	},

	addLocation({commit, rootState}, dataIndex){
		console.log("addLocation: "+dataIndex);

		var user = rootState.auth.user;
		var clientId = user.client_id

		commit('ADD_LOCATION', {dataIndex: dataIndex, clientId: clientId});

	},

	create({commit, dispatch, state, getters, rootState, rootGetters}, val){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/client-create-locations';

		var locationNum = Number(val);
		var locationData;

		// call action to replace location_name
		switch(locationNum){
			case 0:
				//locationData = state.location0
				dispatch('replaceLocationName', state.location0)
				//commit('REPLACE_LOCATION_NAME', state.location0);
				break;
			case 1:
				//locationData = state.location1
				dispatch('replaceLocationName', state.location1)
				//commit('REPLACE_LOCATION_NAME', state.location1);
				break;
			case 2:
				//locationData = state.location2
				dispatch('replaceLocationName', state.location2)
				//commit('REPLACE_LOCATION_NAME', state.location2);
				break;
		}

		// get the updated location_name object
		locationData = state.updatedLocationForServer;

		axios.post(url,locationData,header)
		.then(response => {
			// status 200 = record found
			// status 201 = new record created.
			var status = response.status;
			var newData = response.data.data;
			var locExist = 'locationExist'+locationNum;

			// location found in system
			if(status === 200){
				commit('TOGGLE_BOOLEAN_STATE', {key: locExist, bool: true});
				VueStore.dispatch('notify/setShowMessage', {key: 'showLocationExisted', bool: true})
			// new location created
			} else if(status === 201) {
				//console.log(newData);
				// update location list
            	VueStore.dispatch('global/getLocations');

            	// set active service location name
            	VueStore.dispatch('newRequest/setActiveItem', {type: 'location', key: locationNum, value: newData.location_name});
            	// update dataForServer
            	VueStore.dispatch('newRequest/updateSelectedData', {dataIndex: locationNum, key: 'location_id', value: newData.id})

            	// close location forms
				var addLoc = 'addLocation'+locationNum;
                VueStore.dispatch('newRequest/setShowButton', {key: addLoc, bool: false});

                // hide error message if exist
				commit('TOGGLE_BOOLEAN_STATE', {key: locExist, bool: false});
			}
			//console.log(response.status);
			// get returned location_id and assign to the location
		}).catch((error) => {
			console.log(error);
		});
	},

	replaceLocationName({commit}, locationData){
		var name = locationData.location_name;
		var street = locationData.location_address;
		var city = locationData.location_city;
		var state = locationData.location_state;
		var zip = locationData.location_zipcode;

		var newLocName = name+(name !== '' ? ' - ' : '')+street+','+city+','+state+' '+zip;

		var updatedLocation = {
			client_id: locationData.client_id,
			location_address: locationData.location_address,
			location_city: locationData.location_city,
			location_name: newLocName,
			location_state: locationData.location_state,
			location_zipcode: locationData.location_zipcode,
		};

		//console.log(updatedLocation);
		commit('SET_UPDATED_LOCATION_FOR_SERVER', updatedLocation);
	},

	clear({commit}){
		commit('CLEAR');
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}